import merge from 'lodash/merge';

import { createDashHttpClient, type HttpRequestConfig } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.communityApiUrl, {
  camelizeKeys: true,
});

export async function getConversation(
  {
    conversationId,
    limit,
    after,
    before,
    around,
  }: {
    conversationId: number;
    limit?: number;
    after?: string;
    before?: string;
    around?: string;
  },
  config: HttpRequestConfig = {},
) {
  const url = `/conversations/${conversationId}`;
  return http.get(url, merge({ params: { limit, after, before, around } }, config));
}

export async function createConversationMessage(
  conversationId: number,
  payload: { text: string },
  config: HttpRequestConfig = {},
) {
  const url = `/conversations/${conversationId}/messages`;
  return http.post(url, payload, config);
}

export async function bulkCreateAssignments(
  payload: { interactionIds: number[]; assignedToUser: number | null },
  config: HttpRequestConfig = {},
) {
  return http.post('/community_interactions/assignments', payload, config);
}

export async function updateConversation(
  conversationId: number,
  payload: { assigneeId?: number | null },
  config: HttpRequestConfig = {},
) {
  const url = `/conversations/${conversationId}`;
  return http.patch(url, payload, config);
}

export async function updateConversationMessages(
  conversationId: number,
  payload: { assigneeId?: number; closeConversationMessages?: boolean },
  config: HttpRequestConfig = {},
) {
  const url = `/conversations/${conversationId}/messages`;
  return http.patch(url, payload, config);
}

export async function updateMessage(
  messageId: number,
  payload: { reaction?: string | null },
  config: HttpRequestConfig = {},
) {
  const url = `/messages/${messageId}`;
  return http.patch(url, payload, config);
}
